{
  "slug": "what-is-considered-a-high-iq",
  "title": "ما هو معدل الذكاء المرتفع؟",
  "description": "تعلم أي درجات الذكاء التي عادة ما توصف بأنها عالية، وكيف ترتبط بالمئويات، ولماذا فترات الثقة وسياق الاختبار مهمة.",
  "summary": "على أساس مشترك100)النسبة المئوية(15 مقياس، درجات حول. 120 تفوق المتوسط بكثير وتحصل على درجات تبلغ حوالي 100 130 وتختلف العﻻمات حسب الصك، وﻻ ينبغي أن تحل محل تفسير كامل.",
  "category": "تفسير معدل الذكاء",
  "sections": [
    {
      "heading": "الدرجات المشتركة والنقاط المرجعية للمئويات",
      "paragraphs": [
        "تصف درجات الذكاء الحديثة الأداء مقارنة بمجموعة معيارية قائمة على العمر. وعلى مقياس شائع الاستخدام، 100 نقطة تعادل 1000 نقطة.100قريبة من 50المئين الثانى، 115 بالقرب من 8414 تشرين الأول/أكتوبر 2008 120 بالقرب من 911-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1-1 130 بالقرب من 98(ث) هذه قيم تقريبية مستمدة من نموذج عادي وليست حدوداً قصوى عالمية.",
        "إن الناشرين والمنظمات يستخدمون أوصافاً مختلفة. وقد تكون لمصطلحات مثل فوق المتوسط، أو المتفوق، أو العالي للغاية، أو الموهوبين حدود مختلفة، لذا فإن التقرير والدليل التقني لهما الأولوية."
      ],
      "bullets": [
        "110–119: أعلى من متوسط السكان",
        "120–129: أعلى بكثير من المتوسط على عدة مستويات",
        "130 نسبة 2 في المائة من الدخل المتوسط100, SD- )الجزء اﻷول(15 النموذج"
      ]
    },
    {
      "heading": "يمكن أن يحتوي المركب العالي على شكل غير منتظم",
      "paragraphs": [
        "إن النتيجة الإجمالية تجمع بين قدرات مختارة. فقد يكون أداء شخص ما قوياً بشكل خاص في التفكير اللفظي، أو التفكير البصري، أو الذاكرة العاملة، أو سرعة المعالجة، في حين يكون أداء شخص آخر أقرب إلى متوسط فئة عمره.",
        "إن الصورة الشخصية، وظروف الاختبار، واللغة، والتعليم، والصحة، وسبب التقييم، كل هذا قد يشكل أهمية أكبر من علامة واحدة. والواقع أن النتيجة العالية لا تشير إلى الشخصية، أو الإبداع، أو الدوافع، أو الإنجازات المستقبلية."
      ]
    },
    {
      "heading": "الدقة والترجمة الشفوية المسؤولة",
      "paragraphs": [
        "وتشمل التقارير المهنية عادة فترات ثقة لأن نتيجة قياس مدى الثقة تعتمد على مدى ثقة الباحث في النتائج التي يحصل عليها. 129 لا يفصل بشكل ذي مغزى عن 130 بحد دقيق تماماً",
        "استخدام النتائج على الإنترنت كمعلومات مرجعية إرشادية. ينبغي أن تعتمد القرارات بشأن التعليم، أو الدعم السريري، أو الأهلية على أداة مناسبة خاضعة للإشراف وتفسير مؤهل."
      ]
    }
  ],
  "faqs": [
    {
      "question": "معدل الذكاء 120 مرتفعة؟",
      "answer": "إنها حول 91المئين الأول على أساس متوسط100, SD- )الجزء اﻷول(15 ويوصف عادة بأنه أعلى من المتوسط أيضا، ولكن تختلف العلامات حسب الاختبار."
    },
    {
      "question": "هل معدل الذكاء المرتفع يضمن النجاح؟",
      "answer": "لا، إن الإنجاز يعتمد أيضا على المعرفة، والدوافع، والصحة، والشخصية، والفرص، والمثابرة، والبيئة."
    }
  ],
  "related": ["what-does-an-iq-of-120-mean", "iq-130-meaning", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "قاموس علم النفس - IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "بيرسون - وايس -5 تقرير تقييم العينة",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
